import React, { useEffect, useState } from "react";
import DialogWrapper from "../../DialogWrapper";
import ShareEventVideoComponent from "../../VideoDoorWebRTC/ShareEventVideoComponent";

interface Props {
  startDateISOStr: string;
  durationVideoSeconds: number;
  serialNumber: string;
  title: string;
  shouldOpen: boolean;
  onClose: () => void;
}

const ShareVideoDialog = ({
  startDateISOStr,
  durationVideoSeconds,
  serialNumber,
  title,
  shouldOpen,
  onClose,
}: Props) => {
  const [endVideoDateISOStr, setEndVideoDateISOStr] = useState("");

  const endDateWasUpdated = () => {
    const startDateUnix = new Date(startDateISOStr).getTime();
    const endDateUnix = startDateUnix + durationVideoSeconds * 1000;
    setEndVideoDateISOStr(new Date(endDateUnix).toISOString());
  };

  useEffect(endDateWasUpdated, [startDateISOStr, durationVideoSeconds]);

  return (
    <DialogWrapper open={shouldOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <ShareEventVideoComponent
        time={startDateISOStr}
        serialNumber={serialNumber}
        deviceName={title}
        to={endVideoDateISOStr}
        onClose={onClose}
        useNew={true}
      />
    </DialogWrapper>
  );
};

export default ShareVideoDialog;
